import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "#", -1)
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", { class: "text-center d-none d-sm-table-cell" }, "Puntos a favor", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", { class: "text-center d-none d-sm-table-cell" }, "Puntos en contra", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Diferencia", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", { class: "text-center d-none d-sm-table-cell" }, "G. Muertos", -1)
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center d-none d-sm-table-cell" }
const _hoisted_12 = { class: "text-center d-none d-sm-table-cell" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center d-none d-sm-table-cell" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "Esperando resultados...", -1)
const _hoisted_17 = [
  _hoisted_16
]

import { ClasificacionEquipo } from "@/interfaces/Torneo";



export default /*#__PURE__*/_defineComponent({
  __name: 'TablaClasificacionEquipos',
  props: {
    clasificacion: {},
    esParejas: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_ctx.clasificacion.length > 0)
    ? (_openBlock(), _createBlock(_component_v_table, {
        key: 0,
        density: "compact"
      }, {
        default: _withCtx(() => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_1,
              _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.esParejas ? "Pareja" : "Equipo"), 1),
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clasificacion, (equipo, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: equipo.idEquipo
              }, [
                _createElementVNode("td", _hoisted_8, _toDisplayString(index + 1), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(equipo.nombreEquipo), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(equipo.puntos), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(equipo.puntosFavor), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(equipo.puntosContra), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(equipo.diferencia), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(equipo.lideresMatados), 1)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
}
}

})